import { Controller } from "@hotwired/stimulus"

const WEEKDAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]

export default class extends Controller {
  static targets = ["checkbox", "count", "hint", "dayLabel", "error"]

  connect() {
    this.updateState()
  }

  toggle() {
    const checked = this.checkedBoxes()

    if (checked.length > 2) {
      // Uncheck all and keep only the latest
      this.checkboxTargets.forEach(cb => { cb.checked = false })
      checked[checked.length - 1].checked = true
      this.updateState()
      return
    }

    if (checked.length === 2 && !this.areConsecutive(checked)) {
      // Non-consecutive: keep only the latest click
      const latest = checked[checked.length - 1]
      this.checkboxTargets.forEach(cb => { cb.checked = false })
      latest.checked = true
      this.updateState()
      return
    }

    this.updateState()
  }

  // Private

  checkedBoxes() {
    return this.checkboxTargets.filter(cb => cb.checked)
  }

  areConsecutive(checkedInputs) {
    const indices = checkedInputs.map(cb => WEEKDAYS.indexOf(cb.value)).sort((a, b) => a - b)
    if (indices.length !== 2) return false
    const diff = indices[1] - indices[0]
    return diff === 1 || diff === 6 // 6 handles sat→sun wrap
  }

  adjacentIndices(index) {
    const prev = (index - 1 + 7) % 7
    const next = (index + 1) % 7
    return new Set([prev, next])
  }

  updateState() {
    const checked = this.checkedBoxes()

    if (this.hasCountTarget) {
      this.countTarget.textContent = checked.length
    }

    // Reset all to enabled
    this.checkboxTargets.forEach(cb => { cb.disabled = false })

    if (checked.length === 1) {
      // Disable non-adjacent days
      const selectedIndex = WEEKDAYS.indexOf(checked[0].value)
      const allowed = this.adjacentIndices(selectedIndex)
      allowed.add(selectedIndex) // allow unchecking self

      this.checkboxTargets.forEach(cb => {
        const idx = WEEKDAYS.indexOf(cb.value)
        if (!allowed.has(idx) && !cb.checked) {
          cb.disabled = true
        }
      })
    }

    // Update visual styling for disabled
    if (this.hasDayLabelTarget) {
      this.dayLabelTargets.forEach((label, i) => {
        const cb = this.checkboxTargets[i]
        if (cb && cb.disabled) {
          label.classList.add("opacity-40", "cursor-not-allowed")
          label.classList.remove("cursor-pointer")
        } else {
          label.classList.remove("opacity-40", "cursor-not-allowed")
          label.classList.add("cursor-pointer")
        }
      })
    }

    // Show/hide error hint
    if (this.hasErrorTarget) {
      this.errorTarget.classList.toggle("hidden", checked.length !== 1)
    }
  }
}
